import {
  Button,
  Card,
  Col,
  DatePicker,
  Form,
  Input,
  Modal,
  notification,
  Row,
  Select,
  Space,
  Table,
} from "antd";
import moment from "moment";
import { useEffect, useState } from "react";
import { GET, POST } from "../../utils/apicalls";
import { API } from "../../config/api";
import { v4 as uuidv4 } from "uuid";
import { useNavigate } from "react-router-dom";
import { GrView } from "react-icons/gr";
import PageHeader from "../../admin/pageHeader/pageheader";

function ClientPaymentDetails() {
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(100000);
  const [data, setData] = useState<any>([]);
  const [meta, setMeta] = useState<any>({});
  const [employeeData, setEmployeeData] = useState<any>([]);
  const [selectClientData, setselectClientData] = useState<any>([]);
  const navigate = useNavigate();

  // const user: any = useSelector((state: RootState) => state?.user); // Access user state
  const columns = [
    {
      dataIndex: "type",
      title: "Type",
      render: (type: any) => {
        let color = "";
        switch (type?.toLowerCase()) {
          case "approved":
            color = "green";
            break;
          case "rejected":
            color = "red";
            break;
          default:
            color = "black"; // Default color for other statuses
        }
        return <span style={{ color }}>{type}</span>;
      },
    },
    {
      dataIndex: "category",
      title: "category ",
    },
    {
      dataIndex: "method",
      title: "method ",
    },
    {
      dataIndex: "date",
      title: "date",
      render: (date: any) => (date ? moment(date).format("DD/MM/YYYY") : "-"),
    },

    // {
    //   dataIndex: "employeeId",
    //   title: "Employee",
    //   render: (_: any, value: any) => {
    //     const employeeName = value?.empid?.fullName || "N/A";
    //     return <span>{employeeName}</span>;
    //   },
    // },
    {
      dataIndex: "ClientId",
      title: "Client Name",
      render: (_: any, value: any) => {
        const employeeName = value?.client?.companyName || "N/A";
        return <span>{employeeName}</span>;
      },
    },

    {
      dataIndex: "IN_Amount",
      title: "IN_Amount",
    },
    {
      dataIndex: "OUT_Amount",
      title: "OUT_Amount ",
    },
    {
      dataIndex: "TotalAmount",
      title: "TotalAmount ",
    },

    {
      title: "Action",
      key: "id",
      render: (_: any, record: any) => (
        <Space size="middle">
          <GrView
            color="blue"
            size={20}
            onClick={() => navigate(`/Admin/updatePayroll/${record.id}`)} // Use navigate with a route
          />
        </Space>
      ),
    },
  ];
  const calculateGrandTotal = () => {
    return data.reduce(
      (acc: number, curr: any) => acc + Number(curr.TotalAmount || 0),
      0
    );
  };
  const submitHandler = async (values: any) => {
    try {
      const salaryId = uuidv4();
      const obj = {
        employeeId: values.employeeId,
        salaryId: salaryId,
        ClientId: Number(values.ClientId),
        type: String(values.type),
        date: values.date?.format("YYYY-MM-DD"),
        IN_Amount: Number(values.IN_Amount),
        OUT_Amount: Number(values.OUT_Amount),
        TotalAmount: Number(values.TotalAmount),
        category: values.category,
        method: values.method,
      };

      setIsLoading(true);
      const api = API.CREATE_SALARY_DETAILS;
      const postRequest: any = await POST(api, obj);
      if (postRequest.status) {
        notification.success({ message: "created successfully!" });
        setIsLoading(false);
        setIsModalOpen(false);
        form.resetFields();
        fetchSalary(page, pageSize);
      } else {
        notification.error({ message: "Something went wrong!" });
      }
    } catch (error) {
      console.log(error);
      notification.error({
        message: "Something went wrong! Please try again later.",
      });
      setIsLoading(false);
    }
  };

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    form.resetFields();
  };
  const fetchSalary = async (page: any, values: any) => {
    try {
      setIsLoading(true);
      let obj = {
        query: form.getFieldValue("query"),
        page,
        take: pageSize,
        category: values.category,
      };
      const url = API.LIST_SALARY_DETAILS;
      const response: any = await POST(url, obj);

      // Filter out "payments" and "salary" categories
      const filteredData = response?.data.filter(
        (item: any) => item.category == "payments"
      );

      setData(filteredData);
      setMeta(response?.meta);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchSalary(page, pageSize);
    fetchEmployee();
  }, []);

  const fetchEmployee = async () => {
    try {
      setIsLoading(true);
      const url = API.EMPLOYEE_LISTING;
      const data: any = await GET(url, {});
      if (data?.data) {
        setEmployeeData(data?.data);
      } else {
        console.error("Unexpected data format:", data);
        setEmployeeData([]); // Set to an empty array to prevent errors
      }
    } catch (error) {
      console.error("Error fetching employee data:", error);
      setEmployeeData([]); // Handle errors by setting to an empty array
    } finally {
      setIsLoading(false);
    }
  };
  const fetchClient = async () => {
    try {
      setIsLoading(true);
      const url = API.CLIENT_LISTING;
      const { data }: any = await GET(url, null);
      setselectClientData(data);
      console.log(data);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    fetchClient();
  }, []);

  const filterSalary = async (values: any) => {
    try {
      setIsLoading(true);
      let obj = {
        query: form.getFieldValue("query"),
        category: values.category,
        employeeId: values.employeeId,
        ClientId: values.ClientId,
      };
      const url = API.SEARCH_SALARY_DETAILS;
      const response: any = await POST(url, obj);
      setData(response?.data);
      setMeta(response?.meta);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };
  console.log("object", data)
  return (
    <>
      <PageHeader>
        <Row
          gutter={16}
          style={{ display: "flex", justifyContent: "flex-end" }}
        >
          <Col>
            <Button
              type="primary"
              onClick={showModal}
              style={{ marginRight: "10px" }}
            >
              Create Payroll
            </Button>
          </Col>
        </Row>
      </PageHeader>

      <Card>
        <Form form={form} onFinish={filterSalary} layout="vertical">
          <Row gutter={16}>
            {/* <Col sm={6}>
                {employeeData && (
                  <Form.Item
                    label=" Name"
                    name="employeeId"
                    style={{ marginBottom: 10 }}
                  >
                    <Select placeholder="Select an Name" size="large" allowClear>
                      {employeeData?.map((users: any, i: any) => (
                        <Select.Option key={users?.id} value={Number(users?.id)}>
                          {users?.fullName}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                )}
              </Col> */}
            <Col sm={6}>
              {selectClientData && (
                <Form.Item
                  label="Client Name"
                  name="ClientId"
                  style={{ marginBottom: 10 }}
                >
                  <Select
                    placeholder="Select an Client Name"
                    size="large"
                    allowClear
                  >
                    {selectClientData?.map((users: any, i: any) => (
                      <Select.Option key={users?.id} value={Number(users?.id)}>
                        {users?.companyName}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              )}
            </Col>
            <Col sm={6}>
              <Form.Item name="category" label="Category">
                <Select placeholder="Select a category" allowClear>
                  {/* <Select.Option value="donation">Donation</Select.Option>
                    <Select.Option value="expenses">Expenses</Select.Option> */}
                  {/* <Select.Option value="salary">Salary</Select.Option> */}
                  <Select.Option value="payments">Payments</Select.Option>
                </Select>
              </Form.Item>
            </Col>
            <Row>
              <Col span={24}>
                <Form.Item>
                  <Button
                    type="primary"
                    htmlType="submit"
                    loading={isLoading}
                    block
                  >
                    Search
                  </Button>
                </Form.Item>
              </Col>
            </Row>
          </Row>
        </Form>
      </Card>

      <Modal
        title="Create Payroll"
        visible={isModalOpen}
        onCancel={handleCancel}
        width={1000}
        footer={false}
      >
        <Form form={form} onFinish={submitHandler} layout="vertical">
          <Row gutter={16}>
            {/* <Col sm={6}>
                {employeeData && (
                  <Form.Item
                    label=" Name"
                    name="employeeId"
                    style={{ marginBottom: 10 }}
                  >
                    <Select placeholder="Select an Name" size="large">
                      {employeeData?.map((users: any, i: any) => (
                        <Select.Option key={users?.id} value={Number(users?.id)}>
                          {users?.fullName}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                )}
              </Col> */}
            <Col sm={6}>
              {selectClientData && (
                <Form.Item
                  label="Client Name"
                  name="ClientId"
                  style={{ marginBottom: 10 }}
                >
                  <Select
                    placeholder="Select an Client Name"
                    size="large"
                    allowClear
                  >
                    {selectClientData?.map((users: any, i: any) => (
                      <Select.Option key={users?.id} value={Number(users?.id)}>
                        {users?.companyName}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              )}
            </Col>
            <Col sm={6}>
              <Form.Item
                name="date"
                label="date"
                rules={[{ required: true, message: "Select  date" }]}
              >
                <DatePicker format="DD/MM/YYYY" />
              </Form.Item>
            </Col>
            <Col sm={6}>
              <Form.Item
                name="IN_Amount"
                label="IN_Amount"
                rules={[{ required: true, message: "Enter IN_Amount" }]}
              >
                <Input placeholder="IN_Amount" type="number" />
              </Form.Item>
            </Col>
            <Col sm={6}>
              <Form.Item
                name="OUT_Amount"
                label="OUT_Amount"
                rules={[{ required: true, message: "Enter OUT_Amount" }]}
              >
                <Input placeholder="OUT_Amount" type="number" />
              </Form.Item>
            </Col>
            {/* <Col sm={6}>
              <Form.Item
                name="TotalAmount"
                label="TotalAmount"
                rules={[{ required: true, message: "Enter TotalAmount" }]}
              >
                <Input placeholder="TotalAmount" type="number" />
              </Form.Item>
            </Col> */}
            <Col sm={6}>
              <Form.Item
                name="category"
                label="Category"
                rules={[
                  { required: true, message: "Please select a category!" },
                ]}
              >
                <Select placeholder="Select a category">
                  {/* <Select.Option value="donation">Donation</Select.Option>
                    <Select.Option value="expenses">Expenses</Select.Option> */}
                  {/* <Select.Option value="salary">Salary</Select.Option> */}
                  <Select.Option value="payments">Payments</Select.Option>
                </Select>
              </Form.Item>
            </Col>

            <Col sm={6}>
              <Form.Item
                name="type"
                label="type"
                rules={[{ required: true, message: "Enter type" }]}
              >
                <Select placeholder="Select a type">
                  <Select.Option value="approved">Approved</Select.Option>
                  <Select.Option value="rejected">Rejected</Select.Option>
                </Select>
              </Form.Item>
            </Col>
            <Col sm={6}>
              <Form.Item
                name="method"
                label="method"
                rules={[{ required: true, message: "Enter method" }]}
              >
                <Input placeholder="method" />
              </Form.Item>
            </Col>
          </Row>

          <Row>
            <Col span={24}>
              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  loading={isLoading}
                  block
                >
                  Create Payroll
                </Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
      <Card>
        <Table
          columns={columns}
          dataSource={data}
          pagination={false}
        // pagination={{
        //   current: page,
        //   pageSize: pageSize,
        //   total: meta?.total,
        //   onChange: (page: number, pageSize: number) => {
        //     setPage(page);
        //     setPageSize(pageSize);
        //   },
        // }}
        />
        <Row style={{ marginTop: "20px", textAlign: "right" }}>
          <Col span={24}>
            <h3>
              Grand Total:{" "}
              <span style={{ color: "green" }}>{calculateGrandTotal()}</span>
            </h3>
          </Col>
        </Row>
      </Card>
    </>
  );
}

export default ClientPaymentDetails;
